export const environment = {
  production: true,
  apiUrl: 'https://system.biziclick.com',
  subscriptionApiUrl: 'https://subscription.biziclick.com',
  parameterApiUrl: 'https://parameter.biziclick.com',
  btmApiUrl: "https://btm.biziclick.com",
  clientKey: 'DAGHK9hzzBWj2haLkoFF6HAisMt7huAo',
  clientSecret: 'JTSWiOLipAs1TsCTqfSlhwKeBl1JPzOe'
};



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/environments/environment.ts